(function () {
    'use strict';

    /**
     * Contrôleur pour la gestion des discussions du forum budgétaire
     */
    angular.module('observatoireApp')
        .controller('ForumController', ForumController);

    ForumController.$inject = ['$scope', '$state', '$stateParams', 'ForumApiService', 'BudgetApiService', 'toaster', '$log'];

    function ForumController($scope, $state, $stateParams, ForumApiService, BudgetApiService, toaster, $log) {
        var vm = this;
        
        // Variables
        vm.discussions = [];
        vm.discussion = {};
        vm.newDiscussion = {};
        vm.jeuxDonnees = [];
        vm.selectedJeuDonnees = null;
        vm.showNewDiscussionForm = false;
        vm.isLoading = true;
        vm.formSubmitted = false;
        vm.showDebugPanel = false;
        vm.errorMessage = null;
        
        // Fonctions
        vm.loadAllDiscussions = loadAllDiscussions;
        vm.loadDiscussionsByJeuDonnees = loadDiscussionsByJeuDonnees;
        vm.createDiscussion = createDiscussion;
        vm.updateDiscussion = updateDiscussion;
        vm.deleteDiscussion = deleteDiscussion;
        vm.toggleNewDiscussionForm = toggleNewDiscussionForm;
        vm.resetForm = resetForm;
        vm.filterByJeuDonnees = filterByJeuDonnees;
        vm.clearFilter = clearFilter;
        vm.getJeuDonneesLibelle = getJeuDonneesLibelle;
        
        // Initialisation
        init();
        
        function init() {
            $log.info('ForumController: Initialisation du contrôleur');
            
            // Charger les jeux de données avant tout
            loadJeuxDonnees();
            
            // Gestion du paramètre d'URL pour le filtre
            if ($stateParams.jeuDonneesCode) {
                $log.info('ForumController: Paramètre jeuDonneesCode détecté: ' + $stateParams.jeuDonneesCode);
                vm.selectedJeuDonnees = $stateParams.jeuDonneesCode;
                loadDiscussionsByJeuDonnees($stateParams.jeuDonneesCode);
            } else {
                $log.info('ForumController: Chargement de toutes les discussions');
                loadAllDiscussions();
            }
        }
        
        /**
         * Charge toutes les discussions
         */
        function loadAllDiscussions() {
            vm.isLoading = true;
            vm.errorMessage = null;
            $log.info('ForumController: Chargement de toutes les discussions');
            
            // Ajouter une discussion de test pour vérifier l'affichage
            // Cette discussion sera écrasée si l'API retourne des données
            vm.discussions = [{
                id: 99999,
                titre: "Discussion de test (statique)",
                contenu: "Ceci est une discussion de test pour vérifier l'affichage. Si vous voyez uniquement cette discussion, c'est que l'API ne retourne pas de données.",
                auteur: "Système",
                jeuDonneesCode: "TEST",
                jeuDonneesLibelle: "Jeu de données test",
                createdAt: new Date()
            }];
            
            // Appel de l'API
            ForumApiService.getAllDiscussions()
                .then(function (data) {
                    $log.info('ForumController: API - Données reçues', data);
                    
                    // Vérification des données
                    if (!data) {
                        $log.warn('ForumController: Les données reçues sont null ou undefined');
                        return; // Garde la discussion de test
                    }
                    
                    if (!Array.isArray(data)) {
                        $log.error('ForumController: Les données reçues ne sont pas un tableau');
                        vm.errorMessage = 'Format de données incorrect';
                        return; // Garde la discussion de test
                    }
                    
                    if (data.length === 0) {
                        $log.info('ForumController: Aucune discussion trouvée');
                        // Garde la discussion de test
                    } else {
                        // Remplace la discussion de test par les vraies données
                        vm.discussions = data;
                        $log.info('ForumController: ' + vm.discussions.length + ' discussions chargées');
                        
                        // Débug du premier élément
                        if (vm.discussions.length > 0) {
                            $log.debug('Premier élément:', vm.discussions[0]);
                            
                            // Débogage spécifique des dates
                            vm.discussions.forEach(function(disc, idx) {
                                $log.debug('Discussion #' + idx + ' - ID: ' + disc.id + ' - Dates:', {
                                    createdAt: disc.createdAt,
                                    createdAtType: typeof disc.createdAt,
                                    createdAtIsDate: disc.createdAt instanceof Date,
                                    updatedAt: disc.updatedAt,
                                    updatedAtType: typeof disc.updatedAt,
                                    updatedAtIsDate: disc.updatedAt instanceof Date
                                });
                                
                                // Force à nouveau la conversion des dates si nécessaire
                                if (disc.createdAt && !(disc.createdAt instanceof Date)) {
                                    $log.warn('ForumController: createdAt n\'est pas un objet Date! Tentative de reconversion...');
                                    
                                    // Tentative de reconversion en Date
                                    try {
                                        if (typeof disc.createdAt === 'number') {
                                            // C'est un timestamp
                                            var timestamp = disc.createdAt;
                                            // Si timestamp en secondes (moins de 10 milliards), convertir en ms
                                            if (timestamp < 10000000000) {
                                                timestamp *= 1000;
                                                $log.debug('ForumController: Conversion timestamp secondes -> ms:', timestamp);
                                            }
                                            disc.createdAt = new Date(timestamp);
                                            $log.debug('ForumController: Date après conversion:', disc.createdAt);
                                        }
                                    } catch (e) {
                                        $log.error('ForumController: Erreur de reconversion date:', e);
                                    }
                                }
                            });
                        }
                    }
                })
                .catch(function (error) {
                    $log.error('ForumController: Erreur de chargement des discussions', error);
                    vm.errorMessage = 'Erreur lors du chargement des discussions';
                    toaster.pop('error', 'Erreur', 'Impossible de charger les discussions du forum');
                    // Garde la discussion de test
                })
                .finally(function () {
                    vm.isLoading = false;
                    $log.info('ForumController: Fin du chargement, ' + vm.discussions.length + ' discussions disponibles');
                    
                    // Force une mise à jour du digest cycle si nécessaire
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
        }
        
        /**
         * Charge les discussions d'un jeu de données spécifique
         * @param {String} jeuDonneesCode Code du jeu de données
         */
        function loadDiscussionsByJeuDonnees(jeuDonneesCode) {
            if (!jeuDonneesCode) {
                $log.info('ForumController: Code jeu de données vide, chargement de toutes les discussions');
                loadAllDiscussions();
                return;
            }
            
            vm.isLoading = true;
            vm.errorMessage = null;
            $log.info('ForumController: Chargement des discussions pour le jeu de données ' + jeuDonneesCode);
            
            // Discussion de test filtrée
            vm.discussions = [{
                id: 99998,
                titre: "Discussion de test filtrée",
                contenu: "Ceci est une discussion de test filtrée par jeu de données.",
                auteur: "Système",
                jeuDonneesCode: jeuDonneesCode,
                jeuDonneesLibelle: getJeuDonneesLibelle(jeuDonneesCode) || "Jeu de données " + jeuDonneesCode,
                createdAt: new Date()
            }];
            
            ForumApiService.getDiscussionsByJeuDonnees(jeuDonneesCode)
                .then(function (data) {
                    $log.info('ForumController: API - Données filtrées reçues', data);
                    
                    // Vérification des données
                    if (!data) {
                        $log.warn('ForumController: Les données filtrées reçues sont null ou undefined');
                        return; // Garde la discussion de test
                    }
                    
                    if (!Array.isArray(data)) {
                        $log.error('ForumController: Les données filtrées reçues ne sont pas un tableau');
                        vm.errorMessage = 'Format de données incorrect';
                        return; // Garde la discussion de test
                    }
                    
                    if (data.length === 0) {
                        $log.info('ForumController: Aucune discussion trouvée pour ce jeu de données');
                        // Garde la discussion de test
                    } else {
                        // Remplace la discussion de test par les vraies données
                        vm.discussions = data;
                        $log.info('ForumController: ' + vm.discussions.length + ' discussions filtrées chargées');
                    }
                })
                .catch(function (error) {
                    $log.error('ForumController: Erreur de chargement des discussions filtrées', error);
                    vm.errorMessage = 'Erreur lors du chargement des discussions';
                    toaster.pop('error', 'Erreur', 'Impossible de charger les discussions filtrées');
                    // Garde la discussion de test
                })
                .finally(function () {
                    vm.isLoading = false;
                    $log.info('ForumController: Fin du chargement filtré, ' + vm.discussions.length + ' discussions disponibles');
                    
                    // Force une mise à jour du digest cycle si nécessaire
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
        }
        
        /**
         * Charge la liste des jeux de données
         */
        function loadJeuxDonnees() {
            BudgetApiService.getAllJeuxDonnees()
                .then(function (data) {
                    vm.jeuxDonnees = data;
                    console.log('ForumController: Jeux de données chargés:', vm.jeuxDonnees ? vm.jeuxDonnees.length : 0);
                })
                .catch(function (error) {
                    console.error('ForumController: Erreur lors du chargement des jeux de données:', error);
                    toaster.pop('error', 'Erreur', 'Impossible de charger les jeux de données');
                });
        }
        
        /**
         * Filtre les discussions par jeu de données sélectionné
         */
        function filterByJeuDonnees() {
            console.log('ForumController: Filtrage par jeu de données', vm.selectedJeuDonnees);
            
            if (vm.selectedJeuDonnees) {
                // Mettre à jour l'URL pour refléter le filtre
                $state.go('budget.forum', {jeuDonneesCode: vm.selectedJeuDonnees}, {notify: false});
                loadDiscussionsByJeuDonnees(vm.selectedJeuDonnees);
            } else {
                // Réinitialiser l'URL et charger toutes les discussions
                $state.go('budget.forum', {jeuDonneesCode: null}, {notify: false});
                loadAllDiscussions();
            }
        }

        /**
         * Réinitialise le filtre et charge toutes les discussions
         */
        function clearFilter() {
            vm.selectedJeuDonnees = '';
            $state.go('budget.forum', {jeuDonneesCode: null}, {notify: false});
            loadAllDiscussions();
        }

        /**
         * Obtient le libellé d'un jeu de données à partir de son code
         * @param {String} code Code du jeu de données
         * @return {String} Libellé du jeu de données ou le code si non trouvé
         */
        function getJeuDonneesLibelle(code) {
            if (!code || !vm.jeuxDonnees) {
                return code || 'Non spécifié';
            }
            
            var jeu = vm.jeuxDonnees.find(function(j) {
                return j.code === code;
            });
            
            return jeu ? jeu.libelle : code;
        }
        
        /**
         * Crée une nouvelle discussion
         */
        function createDiscussion() {
            vm.formSubmitted = true;
            
            if (!vm.newDiscussion.titre || !vm.newDiscussion.contenu || !vm.newDiscussion.jeuDonneesCode) {
                toaster.pop('warning', 'Attention', 'Veuillez remplir tous les champs obligatoires');
                return;
            }
            
            ForumApiService.createDiscussion(vm.newDiscussion)
                .then(function (data) {
                    toaster.pop('success', 'Succès', 'Discussion publiée avec succès');
                    vm.showNewDiscussionForm = false;
                    resetForm();
                    
                    // Recharger les discussions selon le filtre actif
                    if (vm.selectedJeuDonnees) {
                        loadDiscussionsByJeuDonnees(vm.selectedJeuDonnees);
                    } else {
                        loadAllDiscussions();
                    }
                })
                .catch(function (error) {
                    toaster.pop('error', 'Erreur', 'Impossible de publier votre discussion');
                });
        }
        
        /**
         * Met à jour une discussion existante
         * @param {Number} id ID de la discussion
         * @param {Object} discussion Objet contenant les données à mettre à jour
         */
        function updateDiscussion(id, discussion) {
            ForumApiService.updateDiscussion(id, discussion)
                .then(function (data) {
                    toaster.pop('success', 'Succès', 'Discussion mise à jour avec succès');
                    
                    // Recharger les discussions selon le filtre actif
                    if (vm.selectedJeuDonnees) {
                        loadDiscussionsByJeuDonnees(vm.selectedJeuDonnees);
                    } else {
                        loadAllDiscussions();
                    }
                })
                .catch(function (error) {
                    toaster.pop('error', 'Erreur', 'Impossible de mettre à jour la discussion');
                });
        }
        
        /**
         * Supprime une discussion
         * @param {Number} id ID de la discussion à supprimer
         */
        function deleteDiscussion(id) {
            if (confirm('Êtes-vous sûr de vouloir supprimer cette discussion ?')) {
                ForumApiService.deleteDiscussion(id)
                    .then(function () {
                        toaster.pop('success', 'Succès', 'Discussion supprimée avec succès');
                        
                        // Recharger les discussions selon le filtre actif
                        if (vm.selectedJeuDonnees) {
                            loadDiscussionsByJeuDonnees(vm.selectedJeuDonnees);
                        } else {
                            loadAllDiscussions();
                        }
                    })
                    .catch(function (error) {
                        toaster.pop('error', 'Erreur', 'Impossible de supprimer la discussion');
                    });
            }
        }
        
        /**
         * Affiche ou masque le formulaire de nouvelle discussion
         */
        function toggleNewDiscussionForm() {
            vm.showNewDiscussionForm = !vm.showNewDiscussionForm;
            if (vm.showNewDiscussionForm) {
                resetForm();
            }
        }
        
        /**
         * Réinitialise le formulaire de nouvelle discussion
         */
        function resetForm() {
            vm.newDiscussion = {
                jeuDonneesCode: vm.selectedJeuDonnees || null
            };
            vm.formSubmitted = false;
            if (vm.discussionForm) {
                vm.discussionForm.$setPristine();
                vm.discussionForm.$setUntouched();
            }
        }
    }
})();
